import { render, staticRenderFns } from "./rawProductsAction.vue?vue&type=template&id=1270d95c&scoped=true"
import script from "./rawProductsAction.vue?vue&type=script&lang=js"
export * from "./rawProductsAction.vue?vue&type=script&lang=js"
import style0 from "./rawProductsAction.vue?vue&type=style&index=0&id=1270d95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1270d95c",
  null
  
)

export default component.exports